export default "__VITE_ASSET__DxcO99PM__"